export default "__VITE_ASSET__cec07f90__"